import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const faqItems = [
    { key: 'faq1Title', keyBody: 'faq1Body' },
    { key: 'faq2Title', keyBody: 'faq2Body' },
    { key: 'faq3Title', keyBody: 'faq3Body' },
    { key: 'faq4Title', keyBody: 'faq4Body' },
    { key: 'faq5Title', keyBody: 'faq5Body' }
];

function FAQ() {
    const { t } = useTranslation();

    return (
        <Container maxWidth="lg">
            <Box sx={{ my: 4 }}>
                <Typography variant="h4" gutterBottom>
                    {t('faqTitle')}
                </Typography>
                {faqItems.map(({ key, keyBody }, idx) => (
                    <Box key={idx} sx={{ mb: 4 }}>
                        <Typography variant="h6" gutterBottom>
                            {t(key)}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t(keyBody)}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Container>
    );
}

export default FAQ;
